module.exports = __webpack_public_path__ + "static/media/261224.d128340c.png";